/**
 * Given a collection of elements that occur in the list, find the minimum and
 * maximum indices of the elements. Any given elements that are not in the list
 * are ignored. Verify that the result is valid by checking that max > min, or
 * max >= min if a zero length result is acceptable.
 */
export const indexRange = <T>(elts: Iterable<T>, list: T[]): [min: number, max: number] => {
    let
        len = list.length,
        min = len - 1,
        max = 0;
    for(const elt of elts) {
        for(let i=0; i < len; i++) {
            if(list[i] === elt) {
                min = Math.min(min, i);
                max = Math.max(max, i);
                break;
            }
        }
    }
    return [min, max];
}
export default indexRange;
